import { put, call, takeEvery } from "redux-saga/effects";
import {
  getProductsAction,
  getProductsSuccess,
  getProductsFailure,
  getProductByIDAction,
  getProductByIDSuccess,
  getProductByIDFailure,
  uploadFile,
  uploadFileSuccess,
  uploadFileFailure,
  getConfigAction,
  getConfigSuccess,
  getConfigFailure,
  getPriceFailure,
  getPriceSuccess,
  getPrice,
} from "../slices/product";
import {
  fetchProducts,
  fetchProductsByID,
  uploadFle,
  getConfigFle,
  fetchPrice,
} from "../apis/product";

// Fetch all products
function* getProducts(action: { type: string; payload: string[] }): Generator {
  try {
    const products: any = yield call(fetchProducts, action.payload);
    yield put(getProductsSuccess(products));
  } catch (error: any) {
    yield put(getProductsFailure(error.message || "Failed to fetch products"));
  }
}

// Fetch product by ID (Fixed)
function* getProductByID(action: { type: string; payload: string }): Generator {
  try {
    const product: any = yield call(fetchProductsByID, action.payload);
    yield put(getProductByIDSuccess(product));
  } catch (error: any) {
    yield put(
      getProductByIDFailure(error.message || "Failed to fetch product"),
    );
  }
}

function* handleUploadFile(action: { type: string; payload: any }): Generator {
  try {
    const file = action.payload as File;
    const product: any = yield call(uploadFle, file);
    yield put(uploadFileSuccess(product));
  } catch (error: any) {
    yield put(uploadFileFailure(error.message || "Failed to fetch product"));
  }
}

function* getConfig(action: { type: string; payload: any }): Generator {
  try {
    const config: any = yield call(getConfigFle, action.payload);
    yield put(getConfigSuccess(config?.data));
  } catch (error: any) {
    yield put(getConfigFailure(error.message || "Failed to fetch config"));
  }
}

function* getPriceAction(action: { type: string; payload: any }): Generator {
  try {
    const data: any = yield call(fetchPrice, action.payload);
    yield put(getPriceSuccess(data));
  } catch (error: any) {
    // Axios interceptor may reject with response.data directly (no .response)
    const data = error?.response?.data ?? error;
    let message = "Failed to fetch price";
    let reason: string | undefined;

    if (typeof data?.message === "string") {
      message = data.message;
    } else if (data?.message && typeof data.message === "object") {
      message =
        (data.message as any).message ||
        (data.message as any).error ||
        message;
      reason = (data.message as any).reason;
    }
    if (typeof data?.reason === "string") {
      reason = data.reason;
    }
    if (message === "Failed to fetch price" && typeof error?.message === "string") {
      message = error.message;
    }

    yield put(getPriceFailure({ message, reason }));
  }
}

// Watcher Saga
export default function* productSaga() {
  yield takeEvery(getProductsAction.type, getProducts);
  yield takeEvery(getProductByIDAction.type, getProductByID);
  yield takeEvery(uploadFile.type, handleUploadFile);
  yield takeEvery(getConfigAction.type, getConfig);
  yield takeEvery(getPrice, getPriceAction);
}
